import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import DomPurify from 'dompurify';
import axios from '../axiosConfig';
import { sendBrochureRequest, sendBrochureResponse } from '../../slices/brochure';
import getHotelPriceDisplayPreference from '../../../helpers/selectors/getHotelPriceDisplayPreference';

function* sendBrochureWorker({
  payload: {
    brochureId,
    savedBrochureId,
    createdFor,
    emailRecipients,
    emailSubject,
    fromEmail,
    emailMessage,
    doUpdatePriceOnPageLoad,
    doSendCopyToAgent,
    doShowPricing,
    doAllowBook,
    editorHTML,
    editorJSON,
    doShowBrochureEditor,
  },
}) {
  try {
    const hotelRateDisplayPreference = yield select(getHotelPriceDisplayPreference(true));
    const { email: loggedInUserEmail } = yield select((store) => store.user);
    const url = '/brochure/updateAndSend';
    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        loggedInUserEmail,
        createdFor,
        emailRecipients,
        emailSubject,
        fromEmail,
        emailMessage,
        brochureId: savedBrochureId,
        doUpdatePriceOnPageLoad,
        doSendCopyToAgent,
        doShowPricing,
        hotelRateDisplayPreference,
        doAllowBook,
        editorHTML: doShowBrochureEditor && editorHTML ? DomPurify.sanitize(editorHTML).replace(/(src|href)="\/\//g, '$1="https://') : '',
        editorJSON: doShowBrochureEditor ? editorJSON : '',
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    yield call(axios, config);

    yield put(sendBrochureResponse({
      brochureId,
    }));
  } catch (error) {
    let errorMessage = 'There is problem with your request. please try again.';
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    }
    yield put(sendBrochureResponse({
      brochureId,
      error: errorMessage,
    }));
  }
}

function* sendBrochureWatcher() {
  yield takeLatest(sendBrochureRequest.toString(), sendBrochureWorker);
}

export default sendBrochureWatcher;
